const development = {
    url: {
        CART_URL: 'https://ecom-uat.viaero.net/customer-svc/c',
        EMAIL_URL: 'https://ecom-uat.viaero.net/customer-svc/e',
        IDI_URL: 'https://ecom-uat.viaero.net/customer-svc/idi',
        INQUIRY_URL: 'https://ecom-uat.viaero.net/customer-svc/i',
        DEVICE_URL: 'https://ecom-uat.viaero.net/customer-svc/d',
        OUTAGE_URL: 'https://ecom-uat.viaero.net/customer-svc/o',
        SEARCH_URL: 'https://ecom-uat.viaero.net/customer-svc/agg',
        STORAGE_URL: 'https://ecom-uat.viaero.net/customer-svc/s',
        NOTIFICATION_URL: 'https://ecom-uat.viaero.net/customer-svc/n',
        PLAN_URL: 'https://ecom-uat.viaero.net/customer-svc/p',
        IDI_BILLING_LOGIN_URL: 'https://myviaero.com/',
        NEWAYA_URL: 'https://ecom-uat.viaero.net/customer-svc/newaya',
        PAYMENT_URL: 'https://ecom-uat.viaero.net/customer-svc/api/v1/payment',
        TEMPUS_URL: 'https://viaeroiframe-pp-prtldev.spectrumretailnet.com/PP',
        PROMO_URL: 'https://ecom-uat.viaero.net/customer-svc/pro',
        STORE_URL: 'https://ecom-uat.viaero.net/customer-svc/z',
        MAPBOX_GEOCODING_URL: 'https://api.mapbox.com/geocoding',
        SAFE_CONN_CONF_URL: 'https://ecom-uat.viaero.net/safe-connections-act/confirmation',
        REFER_A_FRIEND_URL: 'https://info.viaero.com/referafriend/'
    },
    internetOrderEmail: 'support+viaero-dev@solutechnology.com',
    purchaseEmail: 'support+viaero-dev@solutechnology.com',
    inquiryEmail: 'support+viaero-dev@solutechnology.com',
    quoteRequestEmail: 'support+viaero-dev@solutechnology.com',
    creditCheckSuccessEmail: 'support+viaero-dev@solutechnology.com',
    creditCheckAssistanceRequestEmail: 'support+viaero-dev@solutechnology.com',
    creditCheckFailureEmail: 'support+viaero-dev@solutechnology.com',
    paymentFailureEmail: 'support+viaero-dev@solutechnology.com',
    applicationErrorEmail: 'support+viaero-dev@solutechnology.com',
    tempusReferUrl: 'http://localhost:3000/payment',
    // NOTE: Use captchaKey '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' for local development in order to short-circuit reCAPTCHA validation.
    // DO NOT check in changes with '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' as the captcha key for UAT or prod.
    captchaKey: '6Le54vIpAAAAAHjBhRLn30DuleA78X2q6XaZWBJy',
    checkDuplicateAccounts: false,
    mapboxToken:
        'pk.eyJ1IjoiY29sbGluc2NvdmVyYWdlIiwiYSI6ImNrcmM1Y2tlYTR5dncyd282MnV2YWwydzYifQ.9djjn8y1r0D4GI3LddwcKg',
    googleTagSendTo: {
        conversionId: 'AW-1019687854',
        addToCart: 'AW-1019687854/OijKCNzsvrkZEK7nnOYD',
        creditCheck: 'AW-1019687854/7hU2CNCQv7kZEK7nnOYD',
        completedPurchase: 'AW-1019687854/R0gtCNjcz7cZEK7nnOYD'
    },
    reactPixelId: '562039960615534',
    reactPixelDebug: true
};

const uat = {
    url: {
        CART_URL: 'https://ecom-uat.viaero.net/customer-svc/c',
        EMAIL_URL: 'https://ecom-uat.viaero.net/customer-svc/e',
        IDI_URL: 'https://ecom-uat.viaero.net/customer-svc/idi',
        INQUIRY_URL: 'https://ecom-uat.viaero.net/customer-svc/i',
        DEVICE_URL: 'https://ecom-uat.viaero.net/customer-svc/d',
        OUTAGE_URL: 'https://ecom-uat.viaero.net/customer-svc/o',
        SEARCH_URL: 'https://ecom-uat.viaero.net/customer-svc/agg',
        STORAGE_URL: 'https://ecom-uat.viaero.net/customer-svc/s',
        NOTIFICATION_URL: 'https://ecom-uat.viaero.net/customer-svc/n',
        PLAN_URL: 'https://ecom-uat.viaero.net/customer-svc/p',
        IDI_BILLING_LOGIN_URL: 'https://myviaero.com/',
        NEWAYA_URL: 'https://ecom-uat.viaero.net/customer-svc/newaya',
        PAYMENT_URL: 'https://ecom-uat.viaero.net/customer-svc/api/v1/payment',
        TEMPUS_URL: 'https://viaeroiframe-pp-prtldev.spectrumretailnet.com/PP',
        PROMO_URL: 'https://ecom-uat.viaero.net/customer-svc/pro',
        STORE_URL: 'https://ecom-uat.viaero.net/customer-svc/z',
        MAPBOX_GEOCODING_URL: 'https://api.mapbox.com/geocoding',
        SAFE_CONN_CONF_URL: 'https://ecom-uat.viaero.net/safe-connections-act/confirmation',
        REFER_A_FRIEND_URL: 'https://info.viaero.com/referafriend/'
    },
    internetOrderEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    purchaseEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    inquiryEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    quoteRequestEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    creditCheckSuccessEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    creditCheckAssistanceRequestEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    creditCheckFailureEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    paymentFailureEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    applicationErrorEmail:
        'support+viaero-uat@solutechnology.com,lori.searls@viaero.com,caitlin.price@viaero.com,sarah.dirico@viaero.com,Angela.Vontz-Musgrave@viaero.com,matthew.bratrsovsky@viaero.com',
    tempusReferUrl: 'http://localhost:3000/payment',
    // NOTE: Use captchaKey '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' for local development in order to short-circuit reCAPTCHA validation.
    // DO NOT check in changes with '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' as the captcha key for UAT or prod.
    captchaKey: '6Le54vIpAAAAAHjBhRLn30DuleA78X2q6XaZWBJy',
    checkDuplicateAccounts: false,
    mapboxToken:
        'pk.eyJ1IjoiY29sbGluc2NvdmVyYWdlIiwiYSI6ImNrcmM1Y2tlYTR5dncyd282MnV2YWwydzYifQ.9djjn8y1r0D4GI3LddwcKg',
    googleTagSendTo: {
        conversionId: 'AW-1019687854',
        addToCart: 'AW-1019687854/OijKCNzsvrkZEK7nnOYD',
        creditCheck: 'AW-1019687854/7hU2CNCQv7kZEK7nnOYD',
        completedPurchase: 'AW-1019687854/R0gtCNjcz7cZEK7nnOYD'
    },
    reactPixelId: '562039960615534',
    reactPixelDebug: false
};

const production = {
    url: {
        CART_URL: 'https://www.viaero.com/customer-svc/c',
        EMAIL_URL: 'https://www.viaero.com/customer-svc/e',
        IDI_URL: 'https://www.viaero.com/customer-svc/idi',
        INQUIRY_URL: 'https://www.viaero.com/customer-svc/i',
        DEVICE_URL: 'https://www.viaero.com/customer-svc/d',
        OUTAGE_URL: 'https://www.viaero.com/customer-svc/o',
        SEARCH_URL: 'https://www.viaero.com/customer-svc/agg',
        STORAGE_URL: 'https://www.viaero.com/customer-svc/s',
        NOTIFICATION_URL: 'https://www.viaero.com/customer-svc/n',
        PLAN_URL: 'https://www.viaero.com/customer-svc/p',
        IDI_BILLING_LOGIN_URL: 'https://myviaero.com/',
        NEWAYA_URL: 'https://www.viaero.com/customer-svc/newaya',
        PAYMENT_URL: 'https://www.viaero.com/customer-svc/api/v1/payment',
        TEMPUS_URL: 'https://viaeroiframe-pp-prtl.spectrumretailnet.com/PP',
        PROMO_URL: 'https://www.viaero.com/customer-svc/pro',
        STORE_URL: 'https://www.viaero.com/customer-svc/z',
        MAPBOX_GEOCODING_URL: 'https://api.mapbox.com/geocoding',
        SAFE_CONN_CONF_URL: 'https://www.viaero.com/safe-connections-act/confirmation',
        REFER_A_FRIEND_URL: 'https://info.viaero.com/referafriend/'
    },
    internetOrderEmail: 'support+viaero-prod@solutechnology.com,WebOrders@viaero.com',
    purchaseEmail: 'support+viaero-prod@solutechnology.com,WebOrders@viaero.com',
    inquiryEmail: 'support+viaero-prod@solutechnology.com,WebOrders@viaero.com',
    quoteRequestEmail: 'support+viaero-prod@solutechnology.com,WebOrders@viaero.com',
    creditCheckSuccessEmail: 'support+viaero-prod@solutechnology.com,WebOrders@viaero.com',
    creditCheckAssistanceRequestEmail:
        'support+viaero-prod@solutechnology.com,WebOrders@viaero.com',
    creditCheckFailureEmail: 'support+viaero-prod@solutechnology.com,WebOrders@viaero.com',
    paymentFailureEmail: 'support+viaero-prod@solutechnology.com,WebOrders@viaero.com',
    applicationErrorEmail: 'support+viaero-prod@solutechnology.com',
    tempusReferUrl: 'https://www.viaero.com/payment',
    captchaKey: '6LdgnygpAAAAAHiQXi6YEnTrKCtjYyfiZk9Lk7f1',
    checkDuplicateAccounts: true,
    mapboxToken:
        'pk.eyJ1IjoiY29sbGluc2NvdmVyYWdlIiwiYSI6ImNrcmM1Y2tlYTR5dncyd282MnV2YWwydzYifQ.9djjn8y1r0D4GI3LddwcKg',
    googleTagSendTo: {
        conversionId: 'AW-1019687854',
        addToCart: 'AW-1019687854/OijKCNzsvrkZEK7nnOYD',
        creditCheck: 'AW-1019687854/7hU2CNCQv7kZEK7nnOYD',
        completedPurchase: 'AW-1019687854/R0gtCNjcz7cZEK7nnOYD'
    },
    reactPixelId: '562039960615534',
    reactPixelDebug: false
};

let configSettings;

switch (process.env.REACT_APP_ENVIRONMENT?.toLowerCase()) {
    case 'development':
        configSettings = development;
        break;
    case 'uat':
        configSettings = uat;
        break;
    case 'production':
        configSettings = production;
        break;
    default:
        console.log(`Unrecognized environment: ${process.env.REACT_APP_ENVIRONMENT}`);
        configSettings = development;
}

export const Config = configSettings;
